(function () {
  var header = document.querySelector('.header-group');
  if (!header) return;

  var lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
  var ticking = false;
  var threshold = 10;

  header.classList.add('header-group--smart-sticky');

  function headerHeight() {
    return header.offsetHeight || 0;
  }

  function setStickyOffset() {
    document.documentElement.style.setProperty('--theme-sticky-header-height', headerHeight() + 'px');
  }

  function isLocked() {
    var body = document.body;
    return body.classList.contains('mobile-menu-open')
      || body.classList.contains('search-bar-open')
      || header.querySelector('.header-navigation--open')
      || header.querySelector('.header-cart--open')
      || header.querySelector('.site-nav__item--has-dropdown.open');
  }

  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY || window.pageYOffset || 0);
    var diff = y - lastY;

    if (y <= 8) {
      header.classList.remove('header-group--hidden', 'header-group--scrolled');
      lastY = y;
      return;
    }

    header.classList.add('header-group--scrolled');

    if (isLocked()) {
      header.classList.remove('header-group--hidden');
      lastY = y;
      return;
    }

    if (diff > threshold && y > headerHeight()) {
      header.classList.add('header-group--hidden');
    } else if (diff < -threshold) {
      header.classList.remove('header-group--hidden');
    }

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  setStickyOffset();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setStickyOffset);
})();
